import CurrentUserContext from '@/models/current-user-context'
import { Ref } from 'vue'
import { useState } from 'vuex-composition-helpers'

export const useCurrentUser = () => {
  const { context } = useState('permissions', ['context'])
  return context as Ref<CurrentUserContext>
}
